import Button from 'components/form-elements/buttons/Button'
import images from 'assets/images/images'
import { useEffect } from 'react'
import {stages} from 'utils/Constants';
import useTranslate from 'hooks/useTranslate';

const StageForgotNextPassword = ({setRegisterState}) => {
    const {t} = useTranslate()
    useEffect(() => {
        document.title = 'Aktivasyon';
    }, []);

    return (
        <div className="d-flex flex-column gap-4 w-fit-content m-auto">

            <div className='register-container-forgotbtn'>
                <img src={images.checkCircle} alt="" />
            </div>


            <div className='header-m register-container-forgotbtn-text'>
                {t('activationLinkText')}
            </div>
            <div className='register-container-btnGroup stage3-btn-group'>

                <Button onClick={()=> setRegisterState(stages.STAGE_MAIL)} className={"stageTwoBtnRed"} icon={''} text={t('startShopping')} />
            </div>



        </div>
    )
}

export default StageForgotNextPassword